import { get, set } from "local-storage"

export const setPartner = data => set('partner', data)
export const getPartner = () => {
    const p = get('partner')

    return (typeof p === 'object') ? p : null
}
